import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {normalize} from '../../util/utils';
import {concatMergeStrategy} from '../../util/utils';
import {HttpStatusCodes} from '../../util/uiconstants';

export function annotationsReducer(state = initialstate.annotations, action) {
	switch (action.type) {
		case types.GET_TRIAL_BALANCE_BY_ID:
			if (action.response && action.responseObj.status === HttpStatusCodes.Ok) {
				let annotations = [];
				let data = [];

				action.response.map((tb) => {
					data = data.concat(tb.thirdLevelFinancialStatements);
				});

				data
					?.filter((financial) => financial.annotations.length > 0)
					.forEach((financial) => {
						financial.annotations.forEach((annotation) => {
							annotations.push(annotation);
						});
					});
				return {
					...normalize(annotations, undefined, state, concatMergeStrategy)
				};
			}
			return state;
		case types.CREATE_ENTITY_ANNOTATION: {
			if (action.responseObj.status === HttpStatusCodes.Created) {
				// add newly added annotation into annotation list
				return {
					...state,
					byId: {
						...state.byId,
						[action.response.id]: {
							id: action.response.id,
							annotationText: action.response.text
						}
					},
					allIds: state.allIds.concat(action.response.id)
				};
			}
			return state;
		}
		case types.UPDATE_ENTITY_ANNOTATION: {
			if (action.annotation.annotationId) {
				const annotation = action.annotation;
				return {
					...state,
					byId: {
						...state.byId,
						[annotation.annotationId]: {
							...state.byId[annotation.annotationId],
							annotationText: annotation.annotationText
						}
					}
				};
			}
			return state;
		}
		case types.DELETE_ENTITY_ANNOTATION: {
			if (action.responseObj.status === HttpStatusCodes.NoContent) {
				// delete deleted annotation from annotation list
				return {
					...state,
					byId: {
						...state.byId
					},
					allIds: state.allIds.filter((id) => {
						return id !== action.annotation.annotationId;
					})
				};
			}
			return state;
		}
		default:
			return state;
	}
}
